import {Component, OnInit} from '@angular/core';
import {SidebarComponent} from "../../../../layout/sidebar/sidebar.component";
import {ActivatedRoute, Router} from "@angular/router";
import {SideNavService} from "../../../../layout/sidebar/side-name.service";
import {MenusService} from "../../../../../_services/menu.service";
import {Location} from "@angular/common";

@Component({
  selector: 'app-merchant-creation',
  templateUrl: './merchant-creation.component.html',
  styleUrls: ['./merchant-creation.component.scss']
})
export class MerchantCreationComponent implements OnInit {

  isAsideNavCollapsed: boolean = true;
  isAdd: boolean = true;
  isSubMerchant: boolean = false;
  partnerIdentifier: string;
  selectedMerchantId: string;
  resellerName:string;
  resellerMappingLink : string;
  clickEvent: Event;
  menuItems: any;
  public permissions: any;
  public currentPath: any;
  public nextPath: any;
  public previousPath: any;
  private queryParams: any;
  public disableMenu: boolean = true;
  merchantId: any;
  createId: any;
  private readonly hiddenMenuLabels = ['kyc management', 'merchant configuration', 'remarks', 'account addition'];

  constructor(private router: Router, private menuService: MenusService, private location: Location, private route: ActivatedRoute, private sidebarComponent: SidebarComponent, private sideNavService: SideNavService) {
  }

  ngOnInit(): void {
    let path = this.location.prepareExternalUrl(this.location.path());
    console.log(path);
    
    this.currentPath = this.location.path().split('?')[0]
    console.log(this.currentPath)
    this.permissions = this.menuService.getPermissions(this.currentPath);
    console.log(this.permissions);

    const {finalMenus, sidebarMenus, rawMenus} = this.menuService.getMenusItems();
    if (path.charAt(0) === '#') {
      path = path.split('?')[0].slice(1);
    }

    const rawList = rawMenus.find((r: any) => r.MenuLink == path);
    console.log("test"+rawList)
    rawMenus.forEach((x:any)=>console.log(x.MenuLink +" path : "+path))
    const r = rawMenus.filter((r: any) => r.MenuId == rawList.PMenuId || r.PMenuId == rawList.PMenuId)
    console.log("test2")
    const structMenu = this.menuService.structuredMenu(r, rawList.PMenuId);
    console.log("test3")
    this.menuItems = (structMenu?.sidebarMenus || []).filter(
      (m: any) => !this.hiddenMenuLabels.includes((m.label || '').trim().toLowerCase())
    );

    this.setPreNextPaths();
    this.router.events.subscribe((val) => {
      if (this.location.path() != '') {
        this.currentPath = this.location.path()?.split('?')[0];
      } else {
        this.currentPath = this.location.path()?.split('?')[0]
      }
      this.setPreNextPaths();
    });
    this.route.queryParams
      .subscribe(params => {
          this.queryParams = params;
          this.disableMenu = !params.mid;
          if(params.mid){
            this.createId = params.identifier;
            this.merchantId = params.mid;
          }else if(params.rid){
            this.createId= params.rid;
            this.merchantId = params.rid;
            this.resellerName = params.name;
            this.partnerIdentifier = params.identifier;
            this.resellerMappingLink = "/resellers/onboarding/mapping?rid="+this.merchantId;
            console.log(this.resellerMappingLink)
          }else{
            this.createId="Create Merchant"
          }
          
          if (!params.mid) {
            this.router.navigate([this.menuItems[0].link], {
              queryParams: {...this.queryParams}
            })
          }
          console.log(params?.action)
          if (params?.action) {
            this.isAdd = (params.action.toLowerCase() == 'add')
            this.isSubMerchant = (params.action.toLowerCase() == 'mapping')
            console.log(this.isSubMerchant)
          }
        }
      );
    let event = new MouseEvent('click', {bubbles: true});
    // console.log("side---------->",this.sidebarComponent.sideNavService.toggle(event))
    this.sideNavService.sideNavToggleSubject.subscribe((data) => {
    })
  }

  setPreNextPaths() {
    const previousPathIn = this.menuItems.findIndex((f: any) => f.link == this.currentPath) - 1
    this.previousPath = this.menuItems[previousPathIn]?.link
    const nextPathIn = this.menuItems.findIndex((f: any) => f.link == this.currentPath) + 1
    this.nextPath = this.menuItems[nextPathIn]?.link
  }

  previousStep($event: MouseEvent) {
    this.router.navigate([this.previousPath], {
      queryParams: {...this.queryParams}
    })
  }

  nextStep($event: MouseEvent) {
    this.router.navigate([this.nextPath], {
      queryParams: {...this.queryParams}
    })
  }
}
